<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/navigation/header.vue'
import Footer from './components/navigation/footer.vue'
export default {
  components:{
      Header,
      Footer
  },
  name: 'App',
  
  data() {
    return {
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
</style>
